export const gtmClearEcommerceData = () => {
  if (window) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer?.push({ ecommerce: null })
  }
}
